export default {
	header: 'Vyhledat úkol',
	clientName: 'Jméno klienta',
	policyNo: 'Číslo PS',
	taskId: 'ID úkolu',
	taskCreationDate: 'Datum vzniku úkolu',
	taskDeadlineDate: 'Termín splnění úkolu',
	taskType: 'Typ úkolu',
	taskState: 'Stav úkolu',
	taskFinishType: 'Způsob splnění',
	municipality: 'Obec',
	subType: 'Podtyp',
	inTime: 'V termínu',
	afterDeadline: 'Po termínu',
	solver: 'Přiděleno na',
	forwardTask: 'Předat',
	processInformation: 'Zpracovat informace',
	id: 'ID úkolu',
	taskTypeId: 'Typ úkolu',
	taskSubtypeId: 'Podtyp úkolu',
	statusId: 'Stav úkolu',
	finishTypeId: 'Způsob splnění',
	firstName: 'Jméno klienta',
	surname: 'Příjmení klienta',
	personIn: 'Rodné číslo',
	businessName: 'Název klienta',
	businessIn: 'IČO',
	zipCode: 'PSČ',
	login: 'Login zadavatele',
	queueGroupCd: 'Přiděleno na',
	createdFrom: 'Datum vzniku od',
	createdTo: 'Datum vzniku do',
};
